;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('imgOnError', imgOnError)

  /* @ngInject */
  function imgOnError () {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          scope.$apply(attrs.imgOnError)()
        })
      }
    }
  }
})()
